'use client'

import { cn } from '@/_lib/utils'

import { PATIENT_INFO_FORM_ID } from '../_utils/patient-form.constants'

type APatientInfoFloatingSubmitProps = {
	isLg: boolean
	showFloatingSubmit: boolean
	submitDisabled: boolean
	submitButtonLabel: string
}

export function APatientInfoFloatingSubmit({
	isLg,
	showFloatingSubmit,
	submitDisabled,
	submitButtonLabel
}: APatientInfoFloatingSubmitProps) {
	if (isLg) return null

	return (
		<div
			className={cn(
				'pointer-events-none fixed inset-x-0 bottom-0 z-40 flex justify-center px-4 pb-[max(1rem,env(safe-area-inset-bottom))] pt-3 transition-[opacity,transform] duration-200 ease-out',
				showFloatingSubmit ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'
			)}
			aria-hidden={!showFloatingSubmit}
		>
			<button
				type='submit'
				form={PATIENT_INFO_FORM_ID}
				disabled={submitDisabled}
				tabIndex={showFloatingSubmit ? undefined : -1}
				className={cn(
					'btn_basic cyclamen w-full rounded-[44px] w-fit',
					showFloatingSubmit ? 'pointer-events-auto' : 'pointer-events-none'
				)}
			>
				<span>{submitButtonLabel}</span>
			</button>
		</div>
	)
}
